import {createSlice} from "@reduxjs/toolkit";
import User from "../../models/user";
import {RootState} from "../reducer";

export const AUTH_STATE = {
  NOT_AUTHENTICATED: "NOT_AUTHENTICATED",
  PENDING: "PENDING",
  AUTHENTICATED: "AUTHENTICATED",
  ERROR: "ERROR",
}

export interface SessionState {
  user: User | null;
  authState: string;
}

const initialState: SessionState = {
  user: null,
  authState: AUTH_STATE.NOT_AUTHENTICATED,
}

export const sessionSlice = createSlice({
  name: "session",
  initialState,
  reducers: {
    setUser: (state: { user: any; }, action: { payload: any; }) => {
      state.user = action.payload;
    },
    logout: (state: { user: any; }) => {
      state.user = null;
    },
    setAuthStatus: (state, action) => {
      state.authState = action.payload;
    },
    resetAuthStatus: (state) => {
      state.authState = AUTH_STATE.NOT_AUTHENTICATED;
    }
  }
});

export const {setUser, logout, setAuthStatus, resetAuthStatus} = sessionSlice.actions;

export const selectUser = (state: RootState) => {
  if (state.session.user) {
    return state.session.user;
  }
};

export const selectAuthState = (state: RootState) => {
  return state.session.authState;
}

export default sessionSlice.reducer;